import React, { useState, useEffect } from "react";
import Editor from "@monaco-editor/react";

const defaultCodeSnippets = {
    cpp: `// Write your C++ code here 
#include <iostream>

int main() {
    std::cout << "Hello World!";
    return 0;
}`,
    python: `# Write your Python code here
print("Hello World")`,
    javascript: `// Write your JavaScript code here
console.log("Hi hello");`,
    // Add more languages and their default code snippets here
};

const CodeEditorWindow = ({ onChange, language, code, theme }) => {
    const [value, setValue] = useState(code || defaultCodeSnippets[language] || "");

    useEffect(() => {
        // Update the editor value based on the selected language
        setValue(defaultCodeSnippets[language] || "// Write your code here");
    }, [language]);

    const handleEditorChange = (value) => {
        setValue(value);
        onChange("code", value);
    };

    return (
        <div className="overlay rounded-md overflow-hidden w-full h-full shadow-4xl">
            <Editor
                height="85vh"
                width={`100%`}
                language={language}
                value={value}
                theme={theme}
                onChange={handleEditorChange}
            />
        </div>
    );
};

export default CodeEditorWindow;
